import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";

import { useNavigate } from "react-router-dom";
import { httpDelete, httpGet } from "../../utils/api";
import { BASE_URL } from "../../config/endPoint";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import DashboardLayout from "../../components/layouts/dashboardLayout";

function MetalType() {
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setDeleteId(id);
    setShow(true);
  };

  const getData = async () => {
    await httpGet(`${BASE_URL}/metal/list`)
      .then((res) => {
        if (res?.data?.status) {
          console.log("response", res?.data);
          setData(res.data.response);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const deleteMetalById = async () => {
    setIsLoading(true);
    try {
      await httpDelete(`${BASE_URL}/metal/${deleteId}`).then((res) => {
        if (res?.data?.status) {
          setDeleteId("");
          getData();
          toast.success(res?.data?.message);
          setShow(false);
          setIsLoading(false);
        }
      });
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const columns = [
    {
      name: (
        <h6>
          <b>Category Name</b>
        </h6>
      ),
      selector: (row) => row.cateId.name,
      sortable: true,
    },
    {
      name: (
        <h6>
          <b>Brand Name</b>
        </h6>
      ),
      selector: (row) => row?.barandId?.brandName,
      sortable: true,
    },
    {
      name: (
        <h6>
          <b>Metal Name</b>
        </h6>
      ),
      selector: (row) => row.metalsName,
      sortable: true,
    },
    {
      name: (
        <h6>
          <b>Action</b>
        </h6>
      ),
      cell: (row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "50px",
          }}
        >
          <button
            onClick={() => navigate(`/editMetalType/${row._id} `)}
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            {" "}
            <i className="fa-solid fa-pen fa-lg" style={{ color: "blue" }}></i>
          </button>
          <button
            style={{ border: "none", backgroundColor: "transparent" }}
            type="button"
            onClick={() => handleShow(row._id)}
          >
            {" "}
            <i className="fas fa-trash" style={{ color: "#f00" }}></i>
          </button>
        </div>
      ),
    },
  ];

  const actions = (
    <Button
      className="add-btn"
      type="button"
      onClick={() => navigate("/addMetalType")}
    >
      Add Metal
    </Button>
  );

  return (
    <DashboardLayout>
      <div className="table-outer">
        <DataTable
          title="Metal Type"
          columns={columns}
          data={data}
          pagination
          fixedHeader
          progressPending={isLoading}
          actions={actions}
          // fixedHeaderScrollHeight="500px"
          selectableRowsHighlight
          highlightOnHover
          subHeader
          subHeaderComponent={
            <>
              <input
                type="text"
                placeholder="Search here"
                className="  form-control"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </>
          }
        />

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Delete Metal Type</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure, you want to delete this record?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              No
            </Button>
            <Button variant="primary" onClick={deleteMetalById}>
              {isLoading ? "Deleting..." : "Yes"}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </DashboardLayout>
  );
}

export default MetalType;
